import React, { Component } from 'react';
import { Button, Label } from 'app/components/Basics';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { Table, GenericCell } from '@ecosystem/ui-lib/core/components/Table';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import {AdHocSurveyFormContext} from '../../AdHocSurveyContext'
import Modal from 'app/components/Modal';
import { v4 as uuidv4 } from 'uuid';
import TableDraggableRows from 'app/components/TableDraggableRows';
import './TabQuotasComponent.scss';

class TabQuotas extends Component {
    constructor(props){
        super(props);
        this.state = {     
            errorQuotaText: '',
			showQuotaModal: false,
            limitDisplayMode: 'numeric'
        }    
    }

	componentDidMount() {        
        this.updateAllQuotaPercentages();
    }

	componentDidUpdate() {
		const currentCompletionLimit = this.context.selectedAdHocSurvey.completionLimit;
		if (currentCompletionLimit !== this.prevCompletionLimit) {
			// Update the stored value for next comparison
			this.prevCompletionLimit = currentCompletionLimit;			
			this.updateAllQuotaPercentages();
		}
	}    
   
    calculatePercentage(quotaLimit, completionLimit) {
        if (quotaLimit === undefined || completionLimit <= 0) {
            return undefined;
        }
        return Math.round((quotaLimit / completionLimit) * 100);
    }
    
    calculateNumericFromPercentage(percentage, completionLimit) {
        if (percentage === undefined || completionLimit <= 0) {
            return undefined;
        }
        return Math.round((percentage / 100) * completionLimit);
    }
    
    updateAllQuotaPercentages() {		
        const { selectedAdHocSurvey } = this.context;
        if (!selectedAdHocSurvey.quotaDefinitions) return;
        
        const completionLimit = selectedAdHocSurvey.completionLimit;
        const updatedSurvey = {...selectedAdHocSurvey};
        
        updatedSurvey.quotaDefinitions.forEach(quotaDef => {
            quotaDef.quotaLimitPercentage = this.calculatePercentage(
                quotaDef.quotaLimit, 
                completionLimit
            );
        });
        
        this.context.updateSelectedAdHocSurvey(updatedSurvey);
    }
   
    updateQuotaValue(index, value, mode) {
        const { selectedAdHocSurvey } = this.context;
        const updatedSurvey = {...selectedAdHocSurvey};
        const quotaDef = updatedSurvey.quotaDefinitions[index];
        const completionLimit = updatedSurvey.completionLimit;
        
        if (mode === 'numeric') {
            quotaDef.quotaLimit = value;
            quotaDef.quotaLimitPercentage = this.calculatePercentage(value, completionLimit);
        } else {
            quotaDef.quotaLimitPercentage = value;
            quotaDef.quotaLimit = this.calculateNumericFromPercentage(value, completionLimit);
        }
        
        this.context.updateSelectedAdHocSurvey(updatedSurvey);
    }

	openAddQuotaDefinitionModal() {
		this.setState({showQuotaModal: true});
	}	

	closeQuotaDefinitionModal() {		
		this.setState({
			showQuotaModal: false,
			selectedQuotaDefToAdd: null
		});
	}	

	getTableHeaders() {		
		return [
			{
				id: 'column-quotaname',
				label: 'Quota Definition'
			},
			{
				id: 'column-limit',
				label: 'Limit'
			},
			{
				id: 'column-remove',
				label: 'Remove'
			}
		];
	}

	validateNewOrderedList() {
		return true;		
	}

	updateNewOrderedQuotaDefList(newOrderedList) {
		var selectedAdHocSurvey = this.context.selectedAdHocSurvey;
		selectedAdHocSurvey.quotaDefinitions = newOrderedList;
		this.context.updateSelectedAdHocSurvey(selectedAdHocSurvey);		
	}

	getDraggableRows() {
		const draggableRows = [];       
        this.context.selectedAdHocSurvey.quotaDefinitions.forEach((quotaDefinition, index) => {
            draggableRows.push(this.getDraggableRowCells(quotaDefinition, index));
        });
		return draggableRows;
	}

	getDraggableRowCells(quotaDefinition, index) {
		var draggableRow = {};
		draggableRow.itemId = quotaDefinition.id;
		draggableRow.item = quotaDefinition;
		draggableRow.cells = this.addQuotaDefinitionRow(quotaDefinition, index);
		return draggableRow;
	}

	limitHandler(indexQuotaDef, event) {
		const newValue = event.target.value ? parseInt(event.target.value) : undefined;
        this.updateQuotaValue(indexQuotaDef, newValue, this.state.limitDisplayMode);
	}	

	addQuotaDefinitionRow(quotaDef, indexQuotaDef) {		
		if(quotaDef.tempKey == null) {
			quotaDef.tempKey = uuidv4();
		}
        const cols = [];
        cols.push(<GenericCell className="column-questionset" primary={quotaDef.name}/>);
		cols.push(<GenericCell className="column-limit" primary={<div className={this.state.limitDisplayMode === 'numeric' ? "numeric-input-container" : "percentage-input-container"}>
			<EcoInput
			  disabled={this.userCannotChangeData()}
			  type="number"
			  value={
				this.state.limitDisplayMode === 'numeric'
				  ? quotaDef.quotaLimit
				  : quotaDef.quotaLimitPercentage
			  }
			  onChange={this.limitHandler.bind(this, indexQuotaDef)}
			  key={quotaDef.tempKey}
			  id={quotaDef.tempKey}
			/>
			{this.state.limitDisplayMode === 'percentage' && (
			  <span className="percentage-symbol-inside">%</span>
			)}
		  </div>}/>);		
        cols.push(<GenericCell className="column-remove" primary={<div><ButtonIcon onClick={() => this.addRemoveQuotaDefHandler(quotaDef)} icon={Icons.Close}/></div>}/>);        
        return cols;
    }
	
	userCannotChangeData() {
		return !this.props.canChangeData;
	}	

	getQuotaDefinitionsRow() {
		const rows = [];       
		if (this.context.selectedAdHocSurvey.quotaDefinitions == null
			||this.context.selectedAdHocSurvey.quotaDefinitions.length === 0) {
			return rows;
		}
		
        this.context.selectedAdHocSurvey.quotaDefinitions.forEach((quotaDef, index) => {
            rows.push(this.addQuotaDefinitionRow(quotaDef, index));
        });
		return rows;
	}		

	isAlreadyAdded(quotaDefId) {
		var quota = this.context.selectedAdHocSurvey.quotaDefinitions.find(q=>q.id === quotaDefId);		
		return quota !== undefined
	}

	addRemoveQuotaDefHandler(quotaDef) {
		var quotaDefinitions = this.props.metadata.quotaDefinitions.find(q=>q.id === quotaDef.id);
		var selectedAdHocSurvey = this.context.selectedAdHocSurvey;
		if (!this.isAlreadyAdded(quotaDef.id)) {
            // Add percentage field based on existing quota limit
            const newQuotaDef = {...quotaDefinitions};
            newQuotaDef.quotaLimitPercentage = this.calculatePercentage(
                newQuotaDef.quotaLimit, 
                selectedAdHocSurvey.completionLimit
            );
            
            selectedAdHocSurvey.quotaDefinitions.push(newQuotaDef);
        }
		else {
			let newList = selectedAdHocSurvey.quotaDefinitions.filter(function(f) { return f.id !== quotaDef.id });
			selectedAdHocSurvey.quotaDefinitions = newList;
		}	
		this.context.updateSelectedAdHocSurvey(selectedAdHocSurvey);
	}

	getQuotaDefinitionModalContent() {		
		var rows = [];
        this.props.metadata.quotaDefinitions.forEach((quotaDef) => {
			console.log(quotaDef)
            rows.push(
				(<div className="form-row">
					<div className="form-row-left">{quotaDef.name}</div>
					<div className="form-row-right">
						<div>
							{!this.isAlreadyAdded(quotaDef.id) && <ButtonIcon onClick={() => this.addRemoveQuotaDefHandler(quotaDef)}  icon={Icons.AddPlus}/>}
							{this.isAlreadyAdded(quotaDef.id) && <ButtonIcon onClick={() => this.addRemoveQuotaDefHandler(quotaDef)} icon={Icons.Remove}/>}
						</div>
					</div>
				</div>)
			);
        });

		return rows;		
	}

	getDisplayModeOptions() {
        return [{ value: 'numeric', label: 'Numeric' }, { value: 'percentage', label: 'Percentage' } ];
	}

    getSelectedDisplayModeOption() {		
        return this.getDisplayModeOptions().find(t=> t.value === this.state.limitDisplayMode);
    }

	handleDisplayModeChange(selectedItem) {
        this.setState({ limitDisplayMode: selectedItem.value });
		if (selectedItem.value === 'percentage') {
			this.updateAllQuotaPercentages();
		}
    }

	isPercentageViewEnabled() {
		return this.context.selectedAdHocSurvey.completionLimit > 0;
	}

    render() {
		const draggableRows = this.getDraggableRows();
        return (
            <div className="TabQuotasMinexComponent content-box">
                <Card>
					<div className="form-row">
						<div className="form-row-left">						
							<Label>Limit Display Mode:</Label>
							<Select	id="display-mode"
								value={this.getSelectedDisplayModeOption()}
								onChange={val=>{
									this.handleDisplayModeChange(val)                                
								}}                                
								options={this.getDisplayModeOptions()}
								isDisabled={this.isPercentageViewEnabled() === false}                            
								style={{ width: '150px' }}
							/>
						</div>
						<div className="form-row-right">						
							<Button disabled={this.userCannotChangeData()} secondary icon={<PlusIcon/>} onClick={() => this.openAddQuotaDefinitionModal()}>Quota Definition</Button>
						</div>
                	</div>					
					<TableDraggableRows 
						disabled={this.userCannotChangeData()} 
						tableHeaders={this.getTableHeaders()} 
						tableRows={draggableRows}
						validateNewOrderedList={this.validateNewOrderedList.bind(this)}
						updateNewOrderedList={this.updateNewOrderedQuotaDefList.bind(this)}
						>						
					</TableDraggableRows>

					<div style={{display: draggableRows && draggableRows.length > 0 ? 'none' : 'block' }}>
						<p className='EmptyQuotaListInfoTitle'>Quota Definitions list is empty</p>
						<p className='EmptyQuotaListInfoText'>Please, add quotas via <span className='span-box'>+Quota Definition</span></p>
					</div>

					{this.state.showQuotaModal && ( <Modal content={this.getQuotaDefinitionModalContent()}
					hideConfirmButton
					cancelButtonLabel="Close"
					cancelModalHandler={this.closeQuotaDefinitionModal.bind(this)}
					size="small"
					/>)
					}
                </Card>
            </div>			
        );
    }
}
TabQuotas.contextType = AdHocSurveyFormContext;
export default TabQuotas;